import { Subject } from 'rxjs/Subject';
import { ScreenElementClass } from './../screen-element.class';
import { ICustomPropConfig } from './../../prop-editors.moudule/custom-prop-config.interface';
import { DomSanitizer } from '@angular/platform-browser';
import { SeLiveVideoConfig } from './se-live-video-config.class';
import { Observer } from 'rxjs/Observer';
import { IScreenElement } from './../screen-element.interface';
import {
  Component, OnInit, AfterViewInit, OnDestroy, ViewChild, Injector, ElementRef, ChangeDetectorRef, SimpleChange, Renderer2, EventEmitter
} from '@angular/core';
import { VgAPI } from 'videogular2/core';
import { GlobalPropertiesService } from '../../../../../core.module/services/global-properties.service';
import { LoggerService } from '../../../../../shared/sdk';

@Component({
  selector: 'app-se-livevideo',
  templateUrl: './se-live-video.component.html',
  styleUrls: ['./se-live-video.component.css']
})
export class SeLiveVideoComponent extends ScreenElementClass implements IScreenElement, OnInit, OnDestroy, AfterViewInit {
  public sizeChangeObserver: Observer<{ size: { width: number, height: number } }> = {
    next: (x) => {

    },
    error: (err) => {

    },
    complete: () => {

    }
  };

  public elementConfig = new SeLiveVideoConfig(); // override value of base config;
  public ngUnsubscribe = new Subject(); // for ngUnsubscribe pattern recommended by google
  public videoFinished: EventEmitter<any> = new EventEmitter();

  vgapi: VgAPI;
  public ytplayer; // youtube player api from iframe
  public autoplay = false;
  public playerReady = false;
  public ytCurTimeInterval;
  public currentTime = 0;
  public currentTimeStr = '00:00';

  public state = 'stopped';
  public duration = 0;
  public durationStr = '00:00';

  public playWhenReady = false;

  @ViewChild('video') video;

  get volume() {
    return this.elementConfig.volume;
  }

  set volume(val) {
    if (this.vgapi) {
      this.vgapi.volume = val;
    }

    if (this.ytplayer) {
      this.ytplayer.setVolume(val);
    }

    this.elementConfig.volume = val;
  }


  constructor(
    public injector: Injector,
    public sanitizer: DomSanitizer,
    public elementRef: ElementRef,
    public changeDetectorRef: ChangeDetectorRef,
    public renderer: Renderer2,
    public gps: GlobalPropertiesService,
    public logger: LoggerService
  ) {
    super(sanitizer); // initilize base class
    this.elementConfig = new SeLiveVideoConfig(); // create new config for this element type

    // get inital configs (if passed by injector)
    const startingElementConfig = this.injector.get('elementConfig');  // get commonConfig Value if injected
    if (startingElementConfig) {
      this.elementConfig.fromJson(startingElementConfig);
    }

    this.autoplay = (this.gps.appGlobal.isDesignerMode && this.elementConfig.autoplayInDesigner) || !this.gps.appGlobal.isDesignerMode; // always autoplay for player


  }

  ngOnInit() {
    // this.elementConfig.streamAddress = 'https://1031.myrapid.camera/live/1/live.m3u8';
    // this.elementConfig.hlsSrc = 'https://videorelay.bahlinc.com/hls/main.m3u8';
  }

  ngAfterViewInit() {
    this.onElementReadySubject.next(this);
  }

  ngOnDestroy() {
    if (this.ytCurTimeInterval) {
      clearInterval(this.ytCurTimeInterval);
    }

    // unsub anything else
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  changeHook(change: SimpleChange) {

  }

  pause() {
    if (this.vgapi && this.vgapi.isPlayerReady) {
      this.vgapi.pause();
      this.state = 'paused';
    }

    if (this.ytplayer) {
      this.ytplayer.pauseVideo();
    }

    this.playWhenReady = false;
  }

  stop() {
    if (this.vgapi && this.vgapi.isPlayerReady) {
      this.vgapi.seekTime(0);
      this.vgapi.pause();
      this.state = 'stopped';
    }

    if (this.ytplayer) {
      this.ytplayer.stopVideo();
    }

    this.playWhenReady = false;
  }

  play() {
    if (this.vgapi && this.vgapi.canPlay) {
      this.vgapi.play();
      this.state = 'playing';
    } else if (!this.vgapi || !this.vgapi.canPlay) {
      this.logger.info(`LIVE VIDEO ELEMENT: A play command was received, but the player was not ready.  Will begin playing when ready`);
      this.playWhenReady = true;
    }

    if (this.ytplayer) {
      this.ytplayer.playVideo();

      if (this.ytCurTimeInterval) {
        clearInterval(this.ytCurTimeInterval);
      }

      this.ytCurTimeInterval = setInterval(() => {
        this.currentTime = Math.floor(this.ytplayer.getCurrentTime());
        this.currentTimeStr = this.hhmmss(this.currentTime);
      }, 500);
    }
  }


  toggleMute() {
    if (this.vgapi && this.vgapi.isPlayerReady) {
      this.elementConfig.mute = !this.elementConfig.mute;
      if (this.elementConfig.mute) {
        this.vgapi.volume = 0;
      } else {
        this.vgapi.volume = this.elementConfig.volume;
      }
    }

    if (this.ytplayer) {
      this.elementConfig.mute = !this.elementConfig.mute;
      if (this.ytplayer.isMuted()) {
        this.ytplayer.unMute();
      } else {
        this.ytplayer.mute();
      }
    }
  }

  onPlayerReady(api: VgAPI) {
    this.vgapi = api;
    this.playerReady = true;
    // this.vgapi.play();

    // set starting volume
    if (this.elementConfig.mute) {
      this.vgapi.volume = 0;
    } else {
      this.vgapi.volume = this.elementConfig.volume;
    }

    this.vgapi.getMasterMedia().subscriptions.timeUpdate.takeUntil(this.ngUnsubscribe).subscribe(value => {
      this.currentTime = isNaN(this.vgapi.currentTime) ? 0 : Math.floor(this.vgapi.currentTime); // set the minimu screentime
      this.currentTimeStr = this.hhmmss(this.currentTime);

      if (this.autoplay || this.playWhenReady) {
        this.vgapi.play();
      }
    });


  }


  // region youtube stuff


  YTInstanceReady(player) {
    this.ytplayer = player;
    this.playerReady = true;

    this.elementConfig.screenTime = this.ytplayer.getDuration(); // set the min screentime
    this.duration = this.ytplayer.getDuration();

    this.durationStr = this.hhmmss(this.duration);
    this.ytplayer.setVolume(this.elementConfig.volume);

    if (this.autoplay || this.playWhenReady) {
      this.ytplayer.playVideo();
    }

  }


  onYTStateChange(event) {
    // console.log('player state', event.data);
    switch (event.data) {
      case -1:
        this.state = 'unstarted';
        break;
      case 0:
        this.state = 'ended';
        break;
      case 1:
        this.state = 'playing';
        break;
      case 2:
        this.state = 'paused';
        break;
      case 3:
        this.state = 'buffering';
        break;
      case 5:
        this.state = 'video cued';
        break;
      default:
        this.state = 'stopped';
        break;
    }


  }

  stopYTVideo() {
    this.ytplayer.stopVideo();
  }

  playYTVideo() {
    this.ytplayer.playVideo();
  }

  // endregion



  getCustomProperties() {

    const userAdjustableProps: ICustomPropConfig[] = new Array;


    const peVideo: ICustomPropConfig = {
      type: 'pe-video',
      name: 'video controls',
      propPath: 'initial',
      defaultValue: 50,
      tooltip: 'Video Controls',
      showDefaultReset: true,
      groupName: null,
      settings: {
        step: 1,
        direction: 'ltr',
        connect: [true, true],
        start: [50],
        range: {
          min: 0,
          max: 100
        },
        // step: .01,
        tooltips: false,
        orientation: 'horizontal',
      }
    };


    userAdjustableProps.push(peVideo);

    return userAdjustableProps;
  }


  pad(num) {
    return ('0' + num).slice(-2);
  }
  hhmmss(secs) {
    const minutes = Math.floor(secs / 60);
    secs = secs % 60;
    // const hours = Math.floor(minutes / 60);
    // minutes = minutes % 60;
    return this.pad(minutes) + ':' + this.pad(secs);
  }


}





// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-live-video/se-live-video.component.ts